@if (isVisible) {
  <div #tooltipEl class="fixed z-[9999] bg-white shadow-lg rounded-lg border border-neutral-200 p-3"
    [style.left.px]="tooltipLeft" [style.top.px]="tooltipTop"
    (mouseleave)="handleMouseLeave()">
    <div class="relative group">
      @if (isAdmin && tooltipData.editable) {
        <div class="absolute top-0 right-0 invisible group-hover:visible bg-white"
          >
          <img src="assets/icons/pencil.svg" alt="edit" class="w-4 h-4 cursor-pointer hover:opacity-80" (click)="switchToEditMode()">
        </div>
      }
      <div>
        @if (isEdit) {
          <div>
            <textarea class="sz-textarea" [(ngModel)]="tooltipData.content"
              style="height: 70px; width: 320px;"
            placeholder="Enter tooltip content" required></textarea>
            @if (!tooltipData.content) {
              <p class="sz-form-error">Please input tooltip content</p>
            }
            <div class="flex justify-center mt-1">
              <button class="sz-btn-outline mr-2" [disabled]="isSaving" (click)="handleCancel()">Cancel</button>
              <button class="sz-btn-primary" [disabled]="isDirty || isSaving || !tooltipData.content" (click)="handleSubmit()">Save</button>
            </div>
          </div>
        } @else {
          <div class="whitespace-pre-line"
            [ngClass]="tooltipData.content ? 'max-w-[320px]' : 'min-w-[150px] min-h-[45px]'">
            {{tooltipData.content}}
            @if (extraContent) {
              <div class="whitespace-pre-line text-left mt-1">
                {{extraContent}}
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
